import { useMemo } from "react";
import NeedAttentionFamiliesAction from "./NeedAttentionFamiliesAction";

interface NeedAttentionActionProps {
  speciesTitle: string;
  rows: any[];
}

const NeedAttentionUnifier = ({ speciesTitle, rows }: NeedAttentionActionProps) => {

  const missingItem = 'Maps'

  const toFamilyItem = (row: any) => ({
    id: row.family_id,
    name: row.ui_family_name,
    count: row.family_id,
    provider: row.backend_interface_name,
    configs: row.things_count,
    brands: row.brands_count,
    backendInterfaceId: row.backend_interface_id,
    step: row.step,
  });

  const emptyFamilies = useMemo(
    () => rows.filter((row) => row.is_empty === 1).map(toFamilyItem),
    [rows],
  );
  const missingFamilies = useMemo(
    () => rows.filter((row) => row.is_missing_things === 1).map(toFamilyItem),
    [rows],
  );

  return (
    <NeedAttentionFamiliesAction
      speciesTitle={speciesTitle}
      missingItem={missingItem}
      emptyFamilies={emptyFamilies}
      missingFamilies={missingFamilies}
      emptyMessage="Every unifier family has at least one brand."
      missingMessage="Every unifier family has at least one map."
    />
  );
};

export default NeedAttentionUnifier;
